// extracted by mini-css-extract-plugin
export default {"link":"NavMenu_link__gtBhD"};